/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type HpRespCollectionsModule_homepage$ref: FragmentReference;
export type HpRespCollectionsModule_homepage = {|
  +collectionsModule: ?{|
    +title?: ?string,
    +items?: ?$ReadOnlyArray<?{|
      +cmsId: ?number,
      +title: ?string,
      +link: ?string,
      +imageUrl: ?string,
    |}>,
  |},
  +$refType: HpRespCollectionsModule_homepage$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "HpRespCollectionsModule_homepage",
  "type": "Homepage",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "collectionsModule",
      "name": "module",
      "storageKey": "module(type:\"collections\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "collections",
          "type": "String!"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "CollectionsModule",
          "selections": [
            (v0/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "Product",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cmsId",
                  "args": null,
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "link",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "imageUrl",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '6170ec710515c252de14003c5998fbd9';
module.exports = node;
